<template>
    <b-overlay :show="loading" rounded="sm">
        <div>
        <h4>
            {{
                selectedTemplate && selectedTemplate.name
                ? `${$translate('review_template')}: ${selectedTemplate && selectedTemplate.name
                }`
                : $translate('no_review_template')
            }}
        </h4>

        <b-modal v-model="processModal" id="process-modal" centered header-class="p-0"
            footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" size="lg">
            <template #modal-title="{ ok, cancel }">
                <div class="title-block text-center p-2">
                    {{
                        `${$translate('process')}: ${selectedItem &&
                            selectedItem.checkoff_type &&
                            selectedItem.checkoff_type.name
                            }`
                    }}
                </div>
                <div class="close-btn sm-mt-2" @click="cancel()">×</div>
            </template>
            <b-card no-body v-if="processModal">
                <b-card-body>
                    <view-checkoff-summary v-if="selectedItem.status == 'completed'" :checkoff="selectedItem" />
                    <view-checkoff-form v-else :status="selectedItem.status" v-model="model" ref="checkoffs" />
                </b-card-body>
                <b-card-body>
                    <view-checkoff-attachments :order_id="order.id" :order_checkoff_id="selectedItem.id"
                        @attachment-added="updateStatus"></view-checkoff-attachments>
                </b-card-body>
            </b-card>

            <template #modal-footer="{ ok, cancel }">
                <b-button class="btn-fw" variant="info" @click="submitCheckoff()" v-if="selectedItem.status != 'completed' &&
                    tabIdx === checkoffTabs.summary
                    " v-show="hasPermissionUpdate">
                    {{ $translate('submit') }}
                </b-button>

                <b-button class="btn-fw" variant="info" @click="cancel()">
                    {{ $cancelLabel() }}
                </b-button>
            </template>
        </b-modal>
        <b-table ref="table"  :items="checkoffItems" :class="'edit-div'" responsive :fields="fields" show-empty>
            <template #table-colgroup="scope">
                <col v-for="field in scope.fields" :key="field.key" :style="{
                    width:
                        field.key === 'sequence_no'
                            ? '150px'
                            : field.key !== 'id'
                                ? '350px'
                                : null,
                }" />
            </template>

            <template #cell(status)="{ item }">
                <b-badge :variant="item.status | actionVariant">{{
                    item.status
                }}</b-badge>
            </template>

            <template #cell(action)="{ item }">
                <span :id="'sequence' + item.sequence_no" class="d-inline-block" :title="!viewMode &&
                    item.status != 'completed' &&
                    disabledReview(item)
                    ? checkRoles(item)
                        ? $translate('complete_previous')
                        : $translate('dont_have_permission')
                    : activityReleaseCheck(item) ? $translate('activity_release_first') :''
                    " v-b-tooltip.hover>
                    <b-button size="sm" :disabled="(item.status != 'completed' && viewMode) ||
                        disabledReview(item) || activityReleaseCheck(item) || !editPermission
                        " :variant="item.status | actionVariant" @click="openProcessModal(item)">{{
        actionLabel(item.status) }}</b-button>
                </span>
            </template>
            <template #cell(checkoff_type)="row">
                <h6 v-b-tooltip.hover :title="row.item?.checkoff_type?.description" >{{row.item?.checkoff_type?.name}}</h6>
            </template>
            <template #cell(created_at)="{ value }">
                <h6>{{ value | displayTime }}</h6>
            </template>
            <template #cell(completed_at)="{ value }">
                <h6>{{ value | displayTime }}</h6>
            </template>
            <template #cell(assigned_user_for_notification)="{ item }">
                <span v-if="item.roleOptions && item.roleOptions.length > 0">
                  <multiselect
                    id="input-checkoff_completion_notify_roles"
                    v-model="item.selectedRoles"
                    :options="item.roleOptions"
                    :searchable="true"
                    :multiple="true"
                    :preserve-search="true"
                    :open-direction="'bottom'"
                    label="fullName"
                    track-by="id"
                    :close-on-select="false"
                    :disabled="item.status == 'completed' || viewMode || !editPermission"
                    :limit="2"
                    :append-to-body="true"
                    @open="increaseTableHeight"
                     @close="resetTableHeight"
                      ref="multiselect"
                  >
                  </multiselect>
                  <input type="hidden" v-model="item.checkoff_type_id" />
                </span>
              </template>
              
              
        </b-table>
    </div>
    </b-overlay>
</template>
<script>
import ViewCheckoffSummary from './ViewCheckoffSummary.vue'
import ViewCheckoffForm from './ViewCheckoffForm.vue'
import ViewCheckoffAttachments from './ViewCheckoffAttachments.vue'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import Multiselect from 'vue-multiselect'
export default {
    name: 'orders-Checkoff',
    components: {
        ViewCheckoffSummary,
        ViewCheckoffForm,
        ViewCheckoffAttachments,
        Multiselect
    },
    mixins: [popupMixins, permissionsMixins],
    props: {
        viewMode: { type: Boolean, default: false },
        isNew: { type: Boolean, default: false },
       
        editPermission: {
            type: Boolean,
            default: true
        }
   
    },
    data: () => ({
        processModal: false,
        model: {
            comments: null,
            // completed_at
            officer_name: null,
            checkoff_type_id: null,
            signature_data: null,
        },
        selectedItem: null,
        loading: false,
        tabIdx: 0,
        roleCache: {} 
    }),
    filters: {
        actionVariant(status) {
            switch (status) {
                case 'pending':
                    return 'warning'
                case 'processing':
                    return 'info'
                case 'completed':
                    return 'success'
            }
        },
        displayTime(time) {
            var retutnTime = 'N/A'
            if (time != '') {
                const utc = time.split(' ').join('T').split('.')[0] + '.000Z'
                retutnTime = new Date(utc).toLocaleString()
            }
            return retutnTime
        },
    },
    watch: {
        checkoffs: {
            handler(newCheckoffs) {
                newCheckoffs.forEach(rowItem => {
                    // Watch each row's selectedRoles
                    this.$watch(
                        () => rowItem.selectedRoles,
                        this.emitUpdatedCheckoffs, // Emit the entire updated checkoffs array
                        { deep: true }
                    );
                });
            },
            deep: true, // Ensure the watcher tracks changes within the array and its objects
            immediate: true, // Run this watcher immediately on component mount
        },
    },
    computed: {
        fields() {
            return [
                {
                    key: 'sequence_no',
                    label: this.$translate('no.'),
                },
                {
                    key: 'checkoff_type',
                    label: this.$translate('workflow_step'),
                    formatter: value => value.name,
                },
                { key: 'status', label: this.$translate('status') },
                { key: 'comments', label: this.$translate('comments'), formatter: value => value ? value : 'N/A' },
                { key: 'completed_at', label: this.$translate('done_on') },
                {
                    key: 'user',
                    label: this.$translate('signed'),
                    formatter: x =>
                        ((x || {}).first_name || '') +
                        ' ' +
                        ((x || {}).last_name || ''),
                },
                {
                    key: 'roles',
                    label: this.$translate('roles'),
                    thClass:'order-table-description',
                    tdClass:'order-table-description',
                },
                {
                    key: 'assigned_user_for_notification',
                    label: this.$translate('assigned_user_for_notification'),
                  
                },
                { key: 'action', label: this.$translate('actions') },
            ]
        },
        checkoffTabs() {
            return {
                summary: 0,
                images: 1,
            }
        },
        user() {
            return this.$store.state.user
        },
        order() {
            const item = this.$store.state.orders.item
            console.log('computed---order', item)
            return item || {}
        },
        checkoffs() {
            const item = this.$store.state.orders.checkoffs || []
            console.log('computed---checkoffs', item)
            return item || {}
        },
        checkoffItems() {
            let items = this.checkoffs || []
            //add status
            for (let i = 0; i < items.length; i++) {
                let notify_users = items[i].notify_users;
                const item = items[i]
                const status = item.completed
                    ? 'completed'
                    : item.user_id || item.checkoff_attachments.length
                        ? 'processing'
                        : 'pending'
                this.$set(item, 'status', status)
                this.$set(item, 'roles', item.checkoff_type?.checkoff_type_roles?.map(x=>x.role?.name).join(', '))
                this.$set(items, i, item)

                const roleIds = item.checkoff_type.checkoff_type_roles.map(role => role.role_id);
            //     this.fetchUsersForRoles(roleIds).then(users => {
            //     this.$set(item, 'roleOptions', users);
            //     const notifyUserIds = item.notify_users ? item.notify_users.split(',') : [];
            //     const selectedRoles = users.filter(user => notifyUserIds.includes(user.id.toString()));
            //     this.$set(item, 'selectedRoles', selectedRoles);
            // });
            
            this.fetchUsersForRolesWithCache(roleIds, item);
            }

            //sort
            items.sort((a, b) => a.sequence_no - b.sequence_no)

            //determine active state
            let firstAvailableItem = null
            for (let i = 0; i < items.length; i++) {
                const item = items[i]

                this.$set(item, 'active', false)
                if (!firstAvailableItem && item.status != 'completed') {
                    firstAvailableItem = item
                    this.$set(item, 'active', true)
                }

                if (
                    firstAvailableItem &&
                    item.status != 'completed' &&
                    firstAvailableItem.sequence_no == item.sequence_no
                ) {
                    this.$set(item, 'active', true)
                }

                if (item.status != 'completed') {
                    const user_role = this.user.roles[0].role_id
                    console.log('user role', user_role)
                    const type_roles = item.checkoff_type.checkoff_type_roles
                    console.log('type roles', type_roles)
                    const userHasRole = type_roles.some(
                        x => x.role_id === user_role
                    ) /*  ||  type_roles.length === 0  */
                    console.log('userHasRole', userHasRole)
                    if (item.active) this.$set(item, 'active', userHasRole)
                }
                console.log('item.active', item.active)
                this.$set(items, i, item)
            }

            console.log('Check Off Items - ', items)
            return items
        },
        selectedTemplate() {
            return this.order.checkoff_template
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },
    mounted() {
        console.log('checkoff user', this.user)
        console.log('checkoff order', this.order)
    },
    methods: {
        disabledReview(item) {
            return !item.active && item.status != 'completed'
        },
        checkRoles(item) {
            const userRole = this.user.roles[0].role.name
            const checkReviewRoles =
                item && item.checkoff_type.checkoff_type_roles.some(x =>
                    x.role.name.includes(userRole)
                ) || null
            return !!checkReviewRoles
        },
        activityReleaseCheck(item) {
            return item.checkoff_type && item.checkoff_type.do_release == 1 && (this.order.released == 0 && this.order.completed == 0)
        },
        actionLabel(status) {
            switch (status) {
                case 'pending':
                case 'processing':
                    return this.$translate('process')
                case 'completed':
                    return this.$translate('view')
            }
        },
        openProcessModal(item) {
            this.selectedItem = item
            console.log('item', item)
            this.model.checkoff_type_id = item.checkoff_type_id
            this.model.comments = item.comments
            this.model.completed = item.completed
            this.model.notes = item.checkoff_type?.description
            console.log('model before', this.model)
            this.processModal = true
        },

        getPosition(options) {
            return new Promise((resolve, reject) =>
                navigator.geolocation.getCurrentPosition(
                    resolve,
                    reject,
                    options
                )
            )
        },

        updateStatus() {
            if (!this.selectedItem.user_id) {
                this.submitCheckoff(true)
            }
        },
        async submitCheckoff() {
            
            this.$refs.checkoffs.saveSignature()
            try {
                const hasSignatureData = this.model.signature_data
                if (hasSignatureData !== null) {
                    console.log("gettt")
                    const title = this.$translate('review_completed')
                    const message = `${this.$translate('review_automaticly_completed')}?`
                    const result = await this.confirmMessage(title, message)
                    if (result) {
                        this.model.completed = 1
                        this.loading = true
                        const {
                            order: { id },
                            model: { comments, checkoff_type_id, completed, signature_data },
                        } = this

                        if (!navigator.geolocation) {
                            throw new Error(this.$translate('cannot_identify_location'))
                        }
                        const position = await this.getPosition()

                        let lat = position.coords.latitude
                        let long = position.coords.longitude
                        const data = {
                            checkoff_type_id,
                            comments,
                            officer_name: this.user.first_name + ' ' + this.user.last_name,
                            signature_data,
                            lat,
                            long,
                            completed,
                        }
                      
                        const path = 'orders/updateCheckoff'
                        const order_checkoff_id = this.selectedItem.id

                        await this.$store.dispatch(path, {
                            id,
                            order_checkoff_id,
                            data,
                        })
                        
                        this.processModal = false
                        let status = await this.$store.dispatch('orders/fetchStatus', id);
                        console.log('status data--',status);
                      
                        // console.log('order_completed',order_completed);
                        if(status == 1){
                            console.log('in emit',status);
                            this.$emit('order-completed');
                        }
                        this.$nextTick(()=>{
                            
                            this.genericToast(
                            this.$translate('activity_review'),
                            this.$translate('updated'),
                            'success',
                            `${this.$translate('activity_review')} ${this.$translate(
                                'update_alert'
                            )}`
                        )
                        })
                    }
                } else {
                    this.loading = true
                    const {
                        order: { id },
                        model: { comments, checkoff_type_id, completed, signature_data },
                    } = this
                    if (!navigator.geolocation) {
                        throw new Error(this.$translate('cannot_identify_location'))
                    }
                    const position = await this.getPosition()
                    let lat = position.coords.latitude
                    let long = position.coords.longitude
                    const data = {
                        checkoff_type_id,
                        comments,
                        officer_name: this.user.first_name + ' ' + this.user.last_name,
                        signature_data,
                        lat,
                        long,
                        completed,
                    }
                    const path = 'orders/updateCheckoff'
                    const order_checkoff_id = this.selectedItem.id
                    await this.$store.dispatch(path, {
                        id,
                        order_checkoff_id,
                        data,
                    })
                    this.processModal = false
                    let status = await this.$store.dispatch('orders/fetchStatus', id);
                        console.log('status data--',status);
                      
                        // console.log('order_completed',order_completed);
                        if(status == 1){
                            console.log('in emit',status);
                            this.$emit('order-completed');
                        }
                    this.$nextTick(()=>{
                        this.genericToast(
                        this.$translate('activity_review'),
                        this.$translate('updated'),
                        'success',
                        `${this.$translate('activity_review')} ${this.$translate(
                            'update_alert'
                        )}`
                    )
                    })
                    
                }
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    const errorMessage = error.response.data.error.message;
                   
                    this.doToast(this.$translate('error'), errorMessage, 'danger');
                } else {
                    console.log('this is error!--------', error);
                    this.doToast(this.$translate('error'), error.message, 'danger');
                }
                // this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                
                this.loading = false
            }
        },

        async fetchUsersForRoles(roleIds) {
        console.log('this is called---',roleIds);
        if (roleIds.length > 0) {
            try {
                const response = await this.$store.dispatch("users/fetchUserRole", roleIds);
                if (response && response.data.success.data) {
                    return response.data.success.data.map(user => ({
                        ...user,
                        fullName: `${user.first_name} ${user.last_name} (${user.name})`
                    }));
                } else {
                    console.error('Unexpected response format:', response);
                    return [];
                }
            } catch (error) {
                console.error('Error fetching users:', error);
                return [];
            }
        }
        return [];
      },
      emitUpdatedCheckoffs() {
            // Emit the entire checkoffs array with all updated values
            this.$emit('updateCheckoffData', this.checkoffs);
        },
    //   selectedRoles() {
    //         this.roleOptions.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
    //         var selected = this.roleOptions.filter(s => this.model.checkoff_completion_notify_roles.some(item => s.id == item.id))
    //         var notSelected = this.roleOptions.filter(s => !this.model.checkoff_completion_notify_roles.some(item => s.id == item.id))
    //         this.roleOptions = [...selected, ...notSelected];
    //     },
    sortAndSelectRoles(item) {
        if (!Array.isArray(item.roleOptions)) {
            item.roleOptions = []; // Initialize as an empty array if undefined
        }

        // Separate selected and not selected roles
        const selected = item.roleOptions.filter(role => 
            item.selectedRoles.some(selectedRole => role.id === selectedRole.id)
        );
        const notSelected = item.roleOptions.filter(role => 
            !item.selectedRoles.some(selectedRole => role.id === selectedRole.id)
        );

        // Combine the arrays with selected roles at the top
        item.roleOptions = [...selected, ...notSelected];
    },
    fetchUsersForRolesWithCache(roleIds, item) {
        const roleKey = roleIds.sort().join(','); // Create a unique key based on roleIds

        // Check if the data is already cached
        if (this.roleCache[roleKey]) {
            console.log('Using cached data for roleIds:', roleKey);
            this.$set(item, 'roleOptions', this.roleCache[roleKey]);

            // Process selected roles
            const notifyUserIds = item.notify_users ? item.notify_users.split(',') : [];
            const selectedRoles = this.roleCache[roleKey].filter(user => notifyUserIds.includes(user.id.toString()));
            this.$set(item, 'selectedRoles', selectedRoles);

        } else {
            // If not cached, fetch from API and cache the result
            console.log('Fetching data from API for roleIds:', roleKey);
            this.fetchUsersForRoles(roleIds).then(users => {
                this.$set(item, 'roleOptions', users);
                this.roleCache[roleKey] = users; // Cache the result

                // Process selected roles
                const notifyUserIds = item.notify_users ? item.notify_users.split(',') : [];
                const selectedRoles = users.filter(user => notifyUserIds.includes(user.id.toString()));
                this.$set(item, 'selectedRoles', selectedRoles);
            });
        }
    },
    updateDropdownSize() {
            const ms = this.$refs.multiselect;
            ms.$refs.list.style.width = `${this.$el.clientWidth}px`;
            ms.$refs.list.style.position = 'fixed';
        },
        increaseTableHeight() {
      this.$nextTick(() => {
        const table = this.$refs.table.$el;
        const multiselect = this.$refs.multiselect.$el;
        const dropdownHeight = multiselect.querySelector('.multiselect__content').offsetHeight;
        console.log('table.scrollHeight',table.scrollHeight);
        console.log('dropdownHeight',dropdownHeight);
        // Increase table height to accommodate dropdown
        table.style.height = `${table.scrollHeight + 0}px`;
      });
    },
    resetTableHeight() {
      this.$nextTick(() => {
        const table = this.$refs.table.$el;
        table.style.height = ''; // Reset to default height
      });
    }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.edit-div{
    overflow-y: visible !important;
}
</style>